import { configureStore, Action, isPlain } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { ThunkAction } from "redux-thunk";

import rootReducer, { RootState } from "./rootReducer";
import {
  codeBookApi,
  committeeApi,
  founderApi,
  institutionApi,
  remarkApi,
  requestApi,
  schoolCandidateApi,
} from "../queries";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        isSerializable: (value: any) =>
          value instanceof Date ? true : isPlain(value),
      },
    }).concat(
      codeBookApi.middleware,
      committeeApi.middleware,
      institutionApi.middleware,
      remarkApi.middleware,
      founderApi.middleware,
      requestApi.middleware,
      schoolCandidateApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default store;
